import React, { useEffect, useState } from "react";
import { HiOutlineBellAlert } from "react-icons/hi2";
import ebenchLogo from "../../images/ebench_logo.png";
import { RxHamburgerMenu } from "react-icons/rx";
import { useAdminById } from "../../Hooks/useAdmin";
import {
  GetAllNotification,
  GetUnreadNotificationCount,
  ViewNotification,
} from "../../Services/notificationServices";
import {
  connectWebSocket,
  disconnectWebSocket,
} from "../../utils/websocketService";

const Header = ({ toggleSidebar }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notificationList, setNotificationList] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0); // ✅ number instead of []

  const adminId = localStorage.getItem("adminid");
  const prof = localStorage?.getItem("adminProfile");
  const { data } = useAdminById(adminId || undefined);

  useEffect(() => {
    if (!adminId) return;

    const payload = { id: adminId, role: "ADMIN" };

    const fetchNotifications = async () => {
      try {
        const res = await GetAllNotification(payload);
        const notifications = res?.data?.data || [];
        setNotificationList(notifications);

        // Fetch unread count
        const unreadRes = await GetUnreadNotificationCount(payload);
        setUnreadCount(unreadRes?.data?.unreadCount || 0);
      } catch (error) {
        console.error("Error fetching admin notifications:", error);
      }
    };

    fetchNotifications();

    connectWebSocket(
      payload.role,
      payload.id,
      (newNotification) => {
        if (!newNotification) return;
        console.log("🔔 New Admin Notification:", newNotification);
        setNotificationList((prev) => [newNotification, ...prev]);
        setUnreadCount((prev) => prev + 1);
      },
      (unread) => {
        console.log("📩 Admin Unread Count Updated:", unread);
        setUnreadCount(unread || 0);
      }
    );

    return () => {
      disconnectWebSocket();
    };
  }, [adminId]);

  const handleViewNotification = () => {
    const data = { id: adminId, role: "ADMIN" };
    ViewNotification(data).then(() => {
      setUnreadCount(0);
    });
    GetAllNotification(data).then((res) => {
      setNotificationList(res.data.data);
    });
  };

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = () => setShowNotifications(false);
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // Format "time ago"
  const getTimeAgo = (timestamp) => {
    if (!timestamp) return "Invalid date";

    const now = new Date();
    const created = new Date(Number(timestamp));
    if (isNaN(created.getTime())) return "Invalid date";

    const diffInSeconds = Math.floor((now - created) / 1000);
    if (diffInSeconds < 0) return "Just now";

    if (diffInSeconds < 60)
      return `${diffInSeconds} sec${diffInSeconds !== 1 ? "s" : ""} ago`;
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60)
      return `${diffInMinutes} min${diffInMinutes !== 1 ? "s" : ""} ago`;
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24)
      return `${diffInHours} hr${diffInHours !== 1 ? "s" : ""} ago`;
    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays} day${diffInDays !== 1 ? "s" : ""} ago`;
  };

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "white",
        borderBottom: "1px solid #eee6e4",
      }}
    >
      <div
        style={{
          width: "97%",
          margin: "0 auto",
          height: "4rem",
          display: "flex",
          flexDirection: "row",
        }}
      >
        {/* Left Section */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "15px",
            width: width > 500 ? "80%" : "50%",
          }}
        >
          <div
            style={{
              fontWeight: "600",
              width: width > 500 ? "8rm" : "80px",
              height: "66.67%",
              color: "white",
            }}
          >
            <img
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
              src={ebenchLogo}
              alt="Ebench Logo"
            />
          </div>
          <div
            onClick={toggleSidebar}
            style={{ display: width > 1279 ? "none" : "block" }}
          >
            <RxHamburgerMenu style={{ fontSize: "20px", cursor: "pointer" }} />
          </div>
        </div>

        {/* Right Section */}
        <div
          style={{
            width: width < 1200 ? "60%" : "20%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "15px",
            justifyContent: "flex-end",
          }}
        >
          {/* Notification Bell */}
          <div className="position-relative">
            <HiOutlineBellAlert
              style={{
                fontSize: "1.5rem",
                color: "#286A94",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setShowNotifications((prev) => !prev);
                handleViewNotification();
              }}
            />
            {unreadCount > 0 && (
              <span
                className="position-absolute"
                style={{
                  zIndex: "999",
                  width: "20px",
                  height: "20px",
                  textAlign: "center",
                  borderRadius: "50%",
                  left: "17px",
                  top: "-15px",
                  color: "white",
                  background: "red",
                  fontSize: "13px",
                }}
              >
                {unreadCount}
              </span>
            )}

            {showNotifications && (
              <div
                className="position-absolute border bg-light"
                style={{
                  zIndex: "999",
                  padding: "10px",
                  width: "250px",
                  right: "-50px",
                  top: "30px",
                  boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
                  borderRadius: "6px",
                  maxHeight: "85vh",
                  overflowY: "scroll",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <h6 style={{ marginBottom: "8px", fontWeight: "bold" }}>
                  Notifications
                </h6>
                {notificationList?.length > 0 ? (
                  notificationList.map((n) => {
                    const timeAgo = getTimeAgo(n?.createdDate);
                    return (
                      <div
                        key={n?.notificationId}
                        style={{
                          fontSize: "14px",
                          color: "#555",
                          borderBottom: "1px solid #ddd",
                          paddingBottom: "6px",
                          marginBottom: "6px",
                        }}
                      >
                        🔔 {n?.message}
                        <div style={{ fontSize: "12px", color: "#999" }}>
                          {timeAgo}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p style={{ fontSize: "14px", color: "#555" }}>
                    No new notifications
                  </p>
                )}
              </div>
            )}
          </div>

          {/* Profile */}
          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.5rem",
            }}
          >
            <div style={{ width: "3rem", height: "3rem", borderRadius: "50%" }}>
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
                src={
                  prof && prof !== "undefined"
                    ? prof
                    : "https://img.freepik.com/free-photo/handsome-bearded-guy-posing-against-white-wall_273609-20597.jpg"
                }
                alt="Profile"
              />
            </div>
            <div
              style={{
                fontSize: width > 768 ? "0.875rem" : "12px",
                height: "100%",
                color: "#286A94",
                fontWeight: "600",
                display: width > 500 ? "flex" : "none",
                flexDirection: "column",
                justifyContent: "center",
                gap: 1,
              }}
            >
              <div>{data?.data?.name}</div>
              <div style={{ fontSize: "0.75rem", wordBreak: "break-word" }}>
                Last Login: 03:04:44
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
